import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

type DashboardCardProps = {
  title: string;
  primaryValue: string | number;
  secondaryValue?: string | number;
  icon: React.ReactNode;
};

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  primaryValue,
  secondaryValue,
  icon,
}) => {
  return (
    <Card
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        borderRadius: "12px",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "#05053bff",
          color: "#fff",
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: 120, 
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
          {icon}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            mt: 1,
            flexGrow: 1, 
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {primaryValue}
          </Typography>
          <Typography sx={{ fontWeight: 400, visibility: secondaryValue ? "visible" : "hidden" }}>
            {secondaryValue || "placeholder"}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DashboardCard;